module.exports = __webpack_public_path__ + "img/20210730_121106.85045565.jpg";